import sweealert2 from 'sweetalert2'
const msg = {}
msg.install = (Vue) =>{
    Vue.prototype.$msg ={
        question(texto)
        {
            return sweealert2.fire({
                text:texto,
                icon:'warning',
                iconColor: '#ff4500',
                showCancelButton:true,
                // confirmButtonColor: '#3085d6',
                // cancelButtonColor: '#d33',
                confirmButtonText:'Si',
                cancelButtonText:'No',
                customClass:{
                    htmlContainer:'estilo_texto',
                    confirmButton: 'btn-confirm',
                    cancelButton: 'btn_cancel'
                },
                buttonsStyling: false
            })
        },
        success(texto){
            return sweealert2.fire({
                text:texto,
                icon:'success',
                customClass:{
                    htmlContainer:'estilo_texto',
                    confirmButton: 'btn-confirm',
                },
            })
        },
        warning(texto){
            return sweealert2.fire({
                title:"ChevronCard",
                text:texto,
                icon:'warning',
                color: '#000000',
                iconColor: '#ff4500',
                confirmButtonColor: '#063f6d',
                customClass:{
                    title:'estilo_titulo',
                    htmlContainer:'estilo_texto'
                } 
            })
        },
        error(texto){
            return sweealert2.fire({
                title:"ChevronCard",
                text:texto,
                icon:'error',
                color: '#000000',
                iconColor: '#ff4500',
                confirmButtonColor: '#063f6d',
                customClass:{
                    title:'estilo_titulo',
                    htmlContainer:'estilo_texto'
                }
            })
        },
        info(texto){
            return sweealert2.fire(
                {
                    title:"ChevronCard",
                    text:texto,
                    icon:'info',
                    iconColor: '#ff4500',
                    confirmButtonColor: '#063f6d',
                    customClass:{
                        title:'estilo_titulo',
                        htmlContainer:'estilo_texto'
                    }
                }
            )
        }
    }
}
export default msg;